import API from 'services/TAPS_API';

export default function getCardDocumentTypes(cardTypeId) {
  return API.request({
    method: 'GET',
    url: `/dictionary/card-doc-type?cardTypeId=${cardTypeId}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
